export default __webpack_public_path__ + "static/media/pen-disabled.a0193a72.svg";